module.exports = __webpack_public_path__ + "static/media/credit_mutuel.0e7edfe3.jpg";